module.exports = __webpack_public_path__ + "static/img/14000273.90059ec9.png";